import React, { useState, useEffect } from "react";
import axios from "axios";

// util
import { UpdateURLParameter, GetUrlParams, SlctCityHrefIs } from "./util";

const CurrentCity = () => {
  const currentStatus = {
    Loading: "Loading",
    Success: "Success",
    NotExist: "NotExist",
    Error: "Error",
  };

  const [regionCode, setRegionCode] = useState("");
  const [showResults, setShowResults] = useState(currentStatus.Loading);
  const [notExist, setNotExist] = useState("");

  const [codeForFinal, setCodeForFinal] = useState("");

  useEffect(() => {
    const filterCode = parseInt(regionCode.substring(0, 5));
    setCodeForFinal(filterCode);
  }, [regionCode]);

  const getCode = (x, y) => {
    axios
      .get("https://dapi.kakao.com/v2/local/geo/coord2regioncode.json", {
        headers: {
          Authorization: "KakaoAK aedadb13becd112fac339124497bb28c",
        },
        params: {
          x: x,
          y: y,
        },
      })
      .then((response) => {
        const docData = response.data.documents[0];
        const guCodeFromApi = docData.code.substring(0, 5);
        const guCodeGetNotExisted = docData.code.substring(0, 2);

        console.log("type is " + typeof guCodeGetNotExisted);

        const moveToURL = UpdateURLParameter(
          SlctCityHrefIs,
          "guCode",
          guCodeFromApi
        );

        if (guCodeFromApi !== null) {
          if (guCodeGetNotExisted === "36") {
            // 지역코드 앞5자리 - 세종 :  36110
            setNotExist("세종특별시");
            setShowResults(currentStatus.NotExist);
          } else if (guCodeGetNotExisted === "50") {
            // 지역코드 앞 5자리 - 제주도 제주시 : 50110 제주도 서귀포시: 50130
            setNotExist("제주특별자치도");
            setShowResults(currentStatus.NotExist);
          } else {
            setShowResults(currentStatus.Sucess);
            window.location.href = moveToURL;
          }
        }
      })
      .catch((error) => {
        setShowResults(currentStatus.Error);
      });
  };

  if ("geolocation" in navigator) {
    const successCallback = (position) => {
      const lat = position.coords.latitude;
      const lng = position.coords.longitude;
      getCode(lng, lat);
    };

    const errorCallback = (error) => {
      setShowResults(currentStatus.Error);
    };

    navigator.geolocation.getCurrentPosition(successCallback, errorCallback, {
      enableHighAccuracy: true,
      maximumAge: 0,
      timeout: 2000,
    });
  } else {
    setShowResults(currentStatus.Error);
  }

  const Loading = () => {
    return (
      <div className="loading-box">
        <p className="loading-icon loading-animation">
          <span role="img" aria-label="errorEmoji">
            &#x1F41F; &#x1F414; &#x1F364; &#x1F35A; &#x1F372;
          </span>
        </p>
        <p className="loading-message">
          정보를 불러오고 있습니다
          <br /> 잠시만 기다려 주십시오
        </p>
      </div>
    );
  };

  const FailCurrentInfo = () => {
    return (
      <div>
        <div className="loading-box" style={{ top: "30vh" }}>
          <p className="icon-title textCenter">
            <span role="img" aria-label="errorEmoji">
              &#x1F635;
            </span>
          </p>
          <p className="loading-message">
            위치정보를 얻는 데 실패했습니다
            <br />
            궁금한 지역을 직접 검색해보세요
          </p>
          <a href={SlctCityHrefIs}>
            <button className="btn">직접 지역 검색하기</button>
          </a>
        </div>
      </div>
    );
  };

  const NotExist = (props) => {
    return (
      <div>
        <div className="loading-box" style={{ top: "30vh" }}>
          <p className="icon-title textCenter">
            <span role="img" aria-label="errorEmoji">
              &#x1F632;
            </span>
          </p>
          <p className="loading-message">
            혹시 계신 곳이 {props.notExistIs} 인가요?
            <br />
            이 지역은 기초의회가 없는 지역입니다!
            <br />
            아쉽지만 다른 지역을 검색해보세요.
          </p>
          <a href={SlctCityHrefIs}>
            <button className="btn">직접 지역 검색하기</button>
          </a>
        </div>
      </div>
    );
  };

  const CurrentComponent = () => {
    if (showResults === currentStatus.Loading) {
      return <Loading />;
    } else if (showResults === currentStatus.NotExist) {
      return <NotExist notExistIs={notExist} />;
    } else if (showResults === currentStatus.Error) {
      return <FailCurrentInfo />;
    } else {
      return null;
    }
  };
  return (
    <div className="contents">
      <CurrentComponent />
    </div>
  );
};

export default CurrentCity;
